import dynamic from "next/dynamic";
import { Builder } from "@builder.io/react";
import { toolkitColors } from "@/utils/constants";

const ProductCarousel = dynamic(async () => {
  return (await import("./ProductCarousel")).default;
});

const isDemo = 1;

Builder.registerComponent(ProductCarousel, {
  name: "Manual product carousel",
  inputs: [
    {
      name: "carouselTitle",
      type: "string",
      helperText: "Title that is displayed above the Carousel",
    },
    {
      name: "ctaText",
      type: "string",
      helperText: "CTA text displayed to customers",
    },
    {
      name: "ctaUrl",
      type: "link",
      helperText: "Destination url for the CTA",
    },
    {
      name: "backgroundColor",
      type: "string",
      defaultValue: "Oat",
      enum: toolkitColors,
      helperText: "Background color for the Carousel",
    },
    {
      name: "wishlist",
      type: "boolean",
      defaultValue: true,
      helperText:
        "Turn this on to allow customers to add products from this carousel to their wishlist",
    },
    {
      name: "product",
      type: "list",
      subFields: [
        {
          name: "product",
          type: "ShopifyProduct",
          helperText: "Shopify Product Card to be displayed in the Carousel",
        },
      ],
    },
  ],
});
